module.exports = __webpack_public_path__ + "img/003.b9ff40cb.png";